import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { FirebaseAppProvider } from 'reactfire';
const firebaseConfig = {
  apiKey: "AIzaSyAbuLIXwaizyvUVvoPb0c-6U5yejHiu__A",
  authDomain: "manoderecha-61fcb.firebaseapp.com",
  projectId: "manoderecha-61fcb",
  storageBucket: "manoderecha-61fcb.appspot.com",
  messagingSenderId: "140764261040",
  appId: "1:140764261040:web:c518f7b687afbc3b3ca975"
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig} suspense={true}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </FirebaseAppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();